import { GeneralInformationData } from "@/features/privateCompanyLeadsFunnel/types/privateCompanyLead";
import { MaintenanceForwardingEstablishmentChoiceEntryManualEntryData } from "./manualEntry/manualEntry.type";
import { MaintenanceForwardingEstablishmentChoiceEntryAuctionEntryData } from "./auctionEntry/auctionEntry.type";

export enum MaintenanceForwardingEstablishmentChoiceEntryKlass {
  ManualEntry = 'Maintenance::EstablishmentChoice::ManualEntry',
  AuctionEntry = 'Maintenance::EstablishmentChoice::AuctionEntry',
}

export type MaintenanceForwardingEstablishmentChoiceEntryMap = {
  [MaintenanceForwardingEstablishmentChoiceEntryKlass.ManualEntry]: MaintenanceForwardingEstablishmentChoiceEntryManualEntryData;
  [MaintenanceForwardingEstablishmentChoiceEntryKlass.AuctionEntry]: MaintenanceForwardingEstablishmentChoiceEntryAuctionEntryData;
}

export enum MaintenanceForwardingEstablishmentChoiceEntryProposalStatus {
  Canceled = 'canceled',
  AwaitingEstablishmentResponse = 'awaiting_establishment_response',
  AwaitingClientResponse = 'awaiting_client_response',
}

export type MaintenanceForwardingEstablishmentChoiceEntryProposalData = {
  id: string;
  status: MaintenanceForwardingEstablishmentChoiceEntryProposalStatus;
  process_started_at: string | null;
  canceled_at: string | null;
  establishment_accepted_at: string | null;
  establishment_rejected_at: string | null;
  client_accepted_at: string | null;
  client_rejected_at: string | null;
  establishment: {
    id: string;
    general_information: Pick<GeneralInformationData, 'fantasy_name' | 'company_logo'>;
  };
  establishment_accepted_by: string | null;
  establishment_rejected_by: string | null;
  client_accepted_by: string | null;
  client_rejected_by: string | null;
}
